<template>
  <nav v-cloak class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <div class="nav-header text-center">
        <div class="backbar-logo-container">
          <img class="backbar-logo" src="/images/icons/logo-standalone.png" />
          <h2 class="mt-3">BACKBAR</h2>
        </div>
      </div>
      <ul
        id="side-menu"
        class="nav metismenu"
        v-bind:style="{
          opacity: currentVenue && currentVenue.id ? '1' : '0.6',
          pointerEvents: !(currentVenue && currentVenue.id) ? 'none' : 'auto'
        }">
        <li class="">
          <router-link to="/" @click="handleSidebarSideEffects">
            <i class="fas fa-tachometer-alt"></i>
            <span class="nav-label">Dashboard</span>
          </router-link>
        </li>

        <li v-show="showInventory" id="inventory-menu">
          <a>
            <i class="fas fa-pen-square"></i>
            <span class="nav-label">Inventory</span>
            <span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level">
            <li v-show="showInventoryItems">
              <router-link to="/inventory/manage" @click="handleSidebarSideEffects">
                Inventory items
              </router-link>
            </li>
            <li v-show="showRecipes">
              <router-link to="/inventory/recipes" @click="handleSidebarSideEffects">
                Recipes
              </router-link>
            </li>

            <li v-show="showTakeInventory">
              <router-link to="/inventory/audit" @click="handleSidebarSideEffects">
                Take inventory
              </router-link>
            </li>
            <li v-show="showManageLocations">
              <router-link to="/inventory/locations" @click="handleSidebarSideEffects">
                Manage locations
              </router-link>
            </li>
            <li v-show="showManagePars">
              <router-link to="/inventory/manage-par" @click="handleSidebarSideEffects">
                Manage pars
              </router-link>
            </li>
          </ul>
        </li>
        <li v-show="showOrders" id="orders-menu">
          <a>
            <i class="fas fa-shopping-basket"></i>
            <span class="nav-label">Orders</span>
            <span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level">
            <li v-show="showBuildOrders">
              <router-link to="/orders/build" @click="handleSidebarSideEffects">
                Build orders
              </router-link>
            </li>
            <li v-show="showShoppingCart">
              <router-link to="/orders/cart" @click="handleSidebarSideEffects">
                Shopping cart
              </router-link>
            </li>
            <li v-show="showOrderHistory">
              <router-link to="/orders/history" @click="handleSidebarSideEffects">
                Order history
              </router-link>
            </li>
            <li v-show="showManageVendors">
              <router-link to="/orders/vendors" @click="handleSidebarSideEffects">
                Manage vendors
              </router-link>
            </li>
          </ul>
        </li>

        <li v-show="user?.permissions?.modify_menu_preferences || user?.user_level === 9">
          <router-link to="/menu/manage" @click="handleSidebarSideEffects">
            <i class="fas fa-map"></i>
            <span class="nav-label">Menu</span>
          </router-link>
        </li>
        <li v-show="user?.permissions?.manage_pos || user?.user_level === 9" id="sales-menu">
          <a>
            <i class="fas fa-cash-register"></i>
            <span class="nav-label">Sales</span>
            <span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level">
            <li v-show="user?.permissions?.access_sales_reports || user?.user_level === 9">
              <router-link to="/sales/dashboard" @click="handleSidebarSideEffects">
                Dashboard
              </router-link>
            </li>
            <li
              v-show="
                currentVenue.pos &&
                currentVenue.pos.status === 'connected' &&
                currentVenue.pos.has_location === 1 &&
                ((user && user.permissions) || user?.user_level === 9)
              ">
              <router-link to="/sales/map-items" @click="handleSidebarSideEffects">
                Map items
              </router-link>
            </li>
            <li
              v-show="
                currentVenue.pos &&
                currentVenue.pos.status === 'connected' &&
                currentVenue.pos.has_location === 1 &&
                ((user && user.permissions) || user?.user_level === 9)
              ">
              <router-link to="/sales/map-modifiers" @click="handleSidebarSideEffects">
                Modifiers
              </router-link>
            </li>
            <li
              v-show="
                currentVenue.pos &&
                currentVenue.pos.status === 'connected' &&
                currentVenue.pos.has_location === 1 &&
                ((user && user.permissions) || user?.user_level === 9)
              ">
              <router-link to="/sales/settings" @click="handleSidebarSideEffects">
                Settings
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-show="
            user &&
            user.permissions &&
            (user?.permissions?.access_inventory_reports ||
              user?.permissions?.access_order_reports ||
              user?.user_level === 9)
          ">
          <router-link to="/reports" @click="handleSidebarSideEffects">
            <i class="fas fa-chart-line"></i>
            <span class="nav-label">Reports</span>
          </router-link>
        </li>
        <li id="support-menu">
          <a>
            <i class="fas fa-question-circle"></i>
            <span class="nav-label">Support</span>
            <span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level">
            <li
              v-show="showGettingStartedLink"
              :class="{ active: $route.path.endsWith('/getting-started') }"
              id="getting-started">
              <router-link to="/getting-started" @click="handleSidebarSideEffects">
                <span>Getting started</span>
              </router-link>
            </li>
            <li>
              <a
                href="https://www.getbackbar.com/support"
                target="_blank"
                @click="handleSidebarSideEffects">
                Help center
              </a>
            </li>
            <li>
              <a
                href="https://www.getbackbar.com/webinar-signup"
                target="_blank"
                @click="handleSidebarSideEffects">
                Training webinars
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="handleSupportClick">Submit support ticket</a>
            </li>
          </ul>
        </li>
        <li v-show="user?.user_level >= 5" id="admin-menu">
          <a>
            <i class="fas fa-tools"></i>
            <span class="nav-label">Admin</span>
            <span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level">
            <li>
              <router-link to="/admin/manage-organizations" @click="handleSidebarSideEffects">
                Organizations
              </router-link>
            </li>
            <li>
              <router-link to="/admin/manage-users" @click="handleSidebarSideEffects">
                Users
              </router-link>
            </li>
            <li>
              <router-link
                v-show="showInvoices"
                to="/admin/manage-invoices"
                @click="handleSidebarSideEffects">
                Invoices
              </router-link>
            </li>
            <li>
              <router-link
                v-show="showManagePOS"
                to="/admin/manage-pos"
                @click="handleSidebarSideEffects">
                Manage POS
              </router-link>
            </li>
            <li>
              <router-link
                v-show="showManagePOS"
                to="/admin/pos-tickets"
                @click="handleSidebarSideEffects">
                POS Tickets
              </router-link>
            </li>
            <li>
              <router-link
                v-show="showManagePOS"
                to="/admin/spoofed-venues"
                @click="handleSidebarSideEffects">
                Spoofed Venues
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <TrialStatusPanel />
    </div>
  </nav>
</template>
<script lang="ts">
import $ from 'jquery'
import 'metismenu/style'
import 'metismenu'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { defineComponent } from 'vue'
import { useSupportModalStore } from '@/stores/support-modal'
import { HUBSPOT_FORM_IDS } from '@/config/constants'
import TrialStatusPanel from './TrialStatusPanel.vue'

export default defineComponent({
  components: {
    TrialStatusPanel
  },
  computed: {
    ...mapState(useUserStore, ['user', 'currentVenue', 'currentOrganization']),

    isDuringOnboarding() {
      const path = this.$route.path
      return (
        path.includes('/welcome') ||
        path.includes('/create-organization') ||
        path.includes('/getting-started')
      )
    },

    showGettingStartedLink() {
      return this.isDuringOnboarding || this.currentVenue?.vip_retailer_id != null
    },

    showInventory() {
      return (
        this.showInventoryItems ||
        this.showRecipes ||
        this.showTakeInventory ||
        this.showManageLocations ||
        this.showManagePars
      )
    },

    showInventoryItems() {
      return this.checkUserPermission('crud_items') || this.checkUserLevel(9)
    },

    showRecipes() {
      return this.showInventoryItems
    },

    showTakeInventory() {
      return this.checkUserPermission('take_inventory') || this.checkUserLevel(9)
    },

    showManageLocations() {
      return this.checkUserPermission('start_end_inventory') || this.checkUserLevel(9)
    },

    showInvoices() {
      return this.checkUserLevel(9)
    },
    showManagePOS() {
      return this.checkUserLevel(9)
    },
    showManagePars() {
      return (
        (this.currentOrganization.plan >= 2 && this.checkUserPermission('crud_items')) ||
        this.checkUserLevel(9)
      )
    },

    showOrders() {
      return (
        this.showBuildOrders ||
        this.showShoppingCart ||
        this.showOrderHistory ||
        this.showManageVendors
      )
    },

    showBuildOrders() {
      return this.checkUserPermission('add_to_shopping_cart') || this.checkUserLevel(9)
    },

    showShoppingCart() {
      return (
        (this.checkUserPermission('add_to_shopping_cart') &&
          this.checkUserPermission('place_orders')) ||
        this.checkUserLevel(9)
      )
    },

    showOrderHistory() {
      return this.checkUserPermission('manage_orders') || this.checkUserLevel(9)
    },

    showManageVendors() {
      return this.showOrderHistory
    }
  },
  mounted() {
    $('#side-menu').metisMenu()
    this.updateMenu()
  },
  methods: {
    ...mapActions(useSupportModalStore, ['openSupportModal']),

    updateMenu() {
      this.$nextTick(() => {
        const menu = $('#side-menu')
        $('#side-menu ul.nav-second-level').css('height', '').removeClass('in')
        menu.metisMenu('dispose')
        menu.metisMenu()
      })
    },

    getHubspotSupportFormId() {
      return HUBSPOT_FORM_IDS.SUPPORT_FORM
    },

    checkUserPermission(permission: string) {
      return this.user?.permissions?.[permission]
    },

    checkUserLevel(level: number) {
      return this.user?.user_level === level
    },

    handleSupportClick() {
      this.openSupportModal(this.getHubspotSupportFormId())
      this.handleSidebarSideEffects()
    },

    closeSidebarIfMobile() {
      if ($('body').hasClass('body-small') && $('body').hasClass('mini-navbar')) {
        $('body').removeClass('mini-navbar')
      }
    },

    handleSidebarSideEffects() {
      this.closeSidebarIfMobile()
    }
  },
  watch: {
    $route: {
      handler() {
        this.updateMenu()
      },
      deep: true,
      immediate: true
    }
  }
})
</script>
<style scoped>
#side-menu > li.mm-active > a .arrow {
  color: #13b9a7;
}
#side-menu .nav-second-level > li:has(a.router-link-exact-active) a,
#side-menu .nav-second-level > li.active a {
  color: #13b9a7;
  background-color: #202a34;
  box-shadow: inset 3px 0 0 0 #13b9a7;
}
</style>
